import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function ScrollTop() {
    const location = useLocation();

    useEffect(() => {
        if(location.pathname) {
            setTimeout(() => {
                window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: "smooth",
                });
            }, 0) 
              
        }
    }, [location.pathname]);

    return null;
}